export default "__VITE_ASSET__BxwZu7DA__"